module.exports = __webpack_public_path__ + "img/avatar0.618c8c56.png";